// Community Parking Management APIs

/**
 * @function ApiClient#GetParkingList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetParkingList(cid, options = {}) {
  return await this._get(`/community/${cid}/parking_list`, options);
}

/**
 * @function ApiClient#AddParking
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingData
 * @param {any} options = {}
 */
export async function AddParking(cid, parkingData, options = {}) {
  return await this._post(`/community/${cid}/parking`, parkingData, options);
}

/**
 * @function ApiClient#UpdateParking
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} parkingData
 * @param {any} options = {}
 */
export async function UpdateParking(cid, parkingData, options = {}) {
  return await this._put(`/community/${cid}/parking`, parkingData, options);
}

/**
 * @function ApiClient#DeleteParking
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vID
 * @param {any} options = {}
 */
export async function DeleteParking(cid, vID, options = {}) {
  return await this._delete(`/community/${cid}/parking/${vID}`, options);
}

/**
 * @function ApiClient#ImportParkingList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} xlsxFile
 * @param {any} options = {}
 */
export async function ImportParkingList(cid, xlsxFile, options = {}) {
  const formData = new FormData();
  formData.set("Xlsx", xlsxFile);
  return await this._post(`/community/${cid}/parking/import`, formData, options);
}
